// components/SortableColumn.jsx

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import BoardData from "../boards/boardData";

const SortableColumn = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "manipulation",
  };

  return (
    <div ref={setNodeRef} style={style} className="drag-grid">
      {/* Add a drag handle you can style freely */}
      <div {...attributes} {...listeners} style={{ cursor: "grab", padding: "4px" }} className="drag-handle">
        {/* <i className="ri-drag-move-2-line"></i>  */}
      </div>

      {/* Your existing BoardData */}
      <BoardData {...props} />
    </div>
  );
};

export default SortableColumn;
